
import messages from '~/locales/myClan.translate'
import sharedMessages from '~/locales/common.translate'
import { mapState } from 'vuex'

export default {
	i18n: {
		messages,
		sharedMessages,
	},
	computed: {
		...mapState(['scToken']),
		...mapState('user', ['userId']),
	},
	data: () => ({
		createWarLoading: false,
		matchCheckInterval: null,
	}),
	props: {
		showModal: {
			type: Boolean,
		},
		matchId: {
			type: String,
		},
	},
	watch: {
		showModal: {
			handler(newValue) {
				if (newValue) {
					this.checkIfMatchStillExists()
					this.matchCheckInterval = setInterval(() => {
						this.checkIfMatchStillExists()
					}, 10000)
					this.createWarLoading = false
				} else if (this.matchCheckInterval) {
					clearInterval(this.matchCheckInterval)
					this.matchCheckInterval = null
				}
			},
			immediate: true,
		},
	},
	methods: {
		async checkIfMatchStillExists() {
			if (!this.matchId) {
				return
			}

			try {
				const matchData = await this.$api.matches.matchSeries.get(this.matchId)

				if (!matchData.data || matchData.data.state !== 'upcoming') {
					this.$emit('close')
				}
			} catch (err) {
				if (err.response && err.response.status === 404) {
					this.$emit('close')
				}
			}
		},
		async startWar() {
			try {
				this.createWarLoading = true
				const warData = await this.$warApi.getWarDeeplink(this.matchId, this.scToken)

				const deeplink = warData.data.link

				if (deeplink) {
					this.$logApi.createLogMessage(
						`start-war-modal executing deeplink for match ${this.matchId}`
					)

					document.location = deeplink

					setTimeout(() => {
						this.$logApi.createLogMessage(
							`start-war-modal executing OpenWar for match ${this.matchId}`
						)
						window.location = 'clashofclans://OpenWar'
					}, 1000)

					setTimeout(() => {
						this.createWarLoading = false
						this.$emit('close')
					}, 2000)
				} else {
					this.$logApi.createLogMessage(
						`start-war-modal did not get deeplink for match ${this.matchId}`
					)
				}
			} catch (err) {
				this.createWarLoading = false
				await this.$logApi.createLogMessage(
					`start-war-modal failed to execute deeplink for match ${this.matchId}`,
					{
						error: JSON.stringify(err),
					}
				)
				this.$store.dispatch('error/handleError', err)
			}
		},
	},
}
